/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlResponse
 */
export interface OmniGenerateIFrameUrlResponse {
    /**
     * 
     */
    iframe_url: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlResponse interface.
 */
export function instanceOfOmniGenerateIFrameUrlResponse(value: object): value is OmniGenerateIFrameUrlResponse {
    if (!('iframe_url' in value) || value['iframe_url'] === undefined) return false;
    return true;
}

export function OmniGenerateIFrameUrlResponseFromJSON(json: any): OmniGenerateIFrameUrlResponse {
    return OmniGenerateIFrameUrlResponseFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'iframe_url': json['iframe_url'],
    };
}

export function OmniGenerateIFrameUrlResponseToJSON(json: any): OmniGenerateIFrameUrlResponse {
    return OmniGenerateIFrameUrlResponseToJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlResponseToJSONTyped(value?: OmniGenerateIFrameUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iframe_url': value['iframe_url'],
    };
}

